import React, { Component } from 'react';
import {
    isIOS,
    isAndroid
} from "react-device-detect";
import Header from './Components/Header/Header';
import './App.css';
import Movie from './Components/Movie/Movie';
import Player from "./Components/reactPlayer";
import {Spinner} from "./Components/spinner";
import { StickyContainer, Sticky } from 'react-sticky';
import moment from "moment";
import Baner from "./Components/Baner/Baner";
import GeolocatedView from "./GeolocatedView";
import LoginView from "./LoginView";
const api_key = 'AIzaSyCMrYjMRxiAgpMHyCFrS3xbyri_Xex0uyI';

class App extends Component {

  constructor(){
    super();

    this.state = {
        movieList: [],
        movieData:null,
        openPlayer:false,
        loading:true,
        showBackButton:false,
        title: 'Shot Tracer',
        geo: false,
        loginEmail: false,
        access: true,
        accessEmailType: 0,
        twoStepVerification:false,
        currentStepVerification:0,
    }
  }

  componentDidMount() {
      //'?year=2020&month=02&day=01')
      //https://event-movies.web.app/?id=1kE5DbGtJNHFY9_EsZNfYmAisFjO25I1e&sub=1

      //https://event-movies.web.app/?9RRRLGCOX=1oKOg9RRRLGCOXGuX15X-9vRv0ABtq57X

      let folderId = '';
      let query = window.location.search.substring(1);
      const params = new URLSearchParams(query);

      if(params.get('GE7KLP1') && params.get('L12J23')) {
          this.setState({twoStepVerification:true, geo: true, access:false, accessEmailType: 0});
      } else if(params.get('GE7KLP1') && params.get('L22J78')) {
          this.setState({twoStepVerification:true, geo: true, access:false, accessEmailType: 1});
      }
      else {
          let geo = params.get('GE7KLP1');
          if (geo) {
              this.setState({geo: true, access: false});
          }
          let login = params.get('L12J23');
          if (login) {
              this.setState({loginEmail: true, access: false, accessEmailType: 0});
          }
          let login2 = params.get('L22J78');
          if (login2) {
              this.setState({loginEmail: true, access: false, accessEmailType: 1});
          }
      }

      folderId = params.get('9RARLolCpX');
      if(!folderId){
          this.setState({loading:false});
      }

      let page = params.get('sub');
      if(page && page === '1') {
          let access = localStorage.getItem('event.movies.folderAccess');
          if(access === null) {
              localStorage.setItem('event.movies.folderAccess', 'true');
              this.setState({loading: false});
              this.fetchData(folderId);
          } else {
              if(access === 'true') {
                  this.setState({showBackButton:true});
                  this.fetchData(folderId);
              } else {
                  this.setState({loading:false});
              }
          }
      } else {
          localStorage.setItem('event.movies.folderAccess', 'true');
          this.setState({loading: false});
          this.fetchData(folderId);
          
      }

      let title = params.get('title');
      if(title){
          if(title.includes("_PM") || title.includes("_AM")) {
              title = title.replace("_", ":");
              title = title.replace("_", " ");
          }
          this.setState({title});
      }
  }

    fetchData = (folderId) => {
        this.setState({loading:true});
        let url = "https://www.googleapis.com/drive/v3/files?q='" + folderId + "'+in+parents&key=" + api_key + '&fields=*'
        fetch(url)
            .then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        movieList: result.files,
                        loading:false
                    });
                    //console.log(result.files);
                },
                (error) => {
                    this.setState({loading:false});
                }
            )
    };

    playMovie = (item) => {
        console.log(item);
        this.setState({openPlayer: !this.state.openPlayer, movieData:item});
    };

    downloadMovie = (item) => {
        console.log(item);

        const link = document.createElement('a');
        link.href = item.webContentLink;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.setState({openPlayer: !this.state.openPlayer});
    };

    openFolder = (item) => {
        console.log(item);
        let url = "https://event-movies.web.app/?9RARLolCpX=" + item.id + '&sub=1' + '&title=' + item.name;
        window.open(url, "_self");
    };

    toggleModal = () => {
        this.setState({openPlayer: !this.state.openPlayer});
    }

    onBack = () => {
        window.history.back();
    }

    onRefresh = () => {
        window.location.reload(true);
    }

    onBannerClicked = () => {
        if(isAndroid) {
            window.open('https://play.google.com/store/apps/details?id=com.visualvertigo.ShotTracer', "_self");
        }else if (isIOS){
            window.open('https://itunes.apple.com/us/app/shot-tracer/id1140451547?mt=8&at=1010lJWo', "_self");
        }else {
            window.open('https://www.shottracerapp.com', "_self");
        }
    };

    getTitle = (name) => {

        let name2 = name;

        console.log('getTitle: ');

        console.log(name2);

        if(name2.includes("_PM") || name2.includes("_AM")) {
            let na = name.split(" ");
            if(na[0]!=null) {
                name2 = na[0];
            }
        }

        let dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
        let title = dateType.test(name2) ? moment(new Date(name2)).format("DD MMM YYYY") : name2;

        if(title.includes("_PM") || title.includes("_AM")) {
            title = title.replace("_", ":");
            title = title.replace("_", " ");
        }

        console.log(title);

        return title;
    }

    newlineText = (txt) => {
        const text = txt;
        return text.split('\n').map(str => <p>{str}</p>);
    }

    freeSwingAnalysis = () => {
        /*let url = 'https://drive.google.com/uc?export=download&id=' + this.state.movieData.id;
        console.log(url);
        let body = "Just recorded this video on Shot Tracer - Smart Tee and would like to request some swing pointers from the local head pro on how to improve. " + '\n\nLink: ' + url;
        console.log(body);
        window.open('mailto:shottracervitals@gmail.com?subject=Free swing analysis request&body=' + body);*/
        if(isAndroid) {
            window.open('https://play.google.com/store/apps/details?id=com.visualvertigo.ShotTracer', "_self");
        }else if (isIOS){
            window.open('https://itunes.apple.com/us/app/shot-tracer/id1140451547?mt=8&at=1010lJWo', "_self");
        }else {
            window.open('https://www.shottracerapp.com', "_self");
        }
    }

    onValidatedEmail = () => {
        if(this.state.currentStepVerification === 1){
            this.setState({access: true});
        }else
        if(this.state.twoStepVerification) {
            this.setState({geo: false, loginEmail: true, access: false, currentStepVerification:1});
        }else {
            this.setState({access: true});
        }
    }

  render() {
    document.body.style = 'background: #F0F3F8;';
    let headerText = this.state.title;
      let cname = this.props.movieListCnt > 1 ? "Movies" : "MoviesCenter";

      return (
      <div className="App">

        <Header className="App-header" text={headerText} onBack={this.onBack} onRefresh={this.onRefresh} showBackButton={this.state.showBackButton}/>
        <div className="Baner-header">       
        </div>

          {this.state.loading && <Spinner></Spinner>}

          {!this.state.access && this.state.geo && <GeolocatedView onValidated={this.onValidatedEmail} loading={this.state.loading}></GeolocatedView>}

          {!this.state.loading && !this.state.access && this.state.loginEmail && <LoginView accessEmailType={this.state.accessEmailType} onValidated={this.onValidatedEmail}></LoginView>}

          {this.state.access && <div className={cname}>

              <div className="MoviesCenter">
                  {this.state.movieList && this.state.movieList.map(
            (item) => {
                return (
                        <Movie
                            playMovie={this.playMovie}
                            downloadMovie={this.downloadMovie}
                            openFolder={this.openFolder}
                            item={item}
                            key = {item.name}
                            title={this.getTitle(item.name)}
                            poster={item.thumbnailLink}
                            year=''
                            description=''
                            mimeType = {item.mimeType}
                            movieListCnt={this.state.movieList.length}
                        >
                        </Movie>
                )
            }
          )}
            </div>
        </div>}
          <Player movieData={this.state.movieData} open={this.state.openPlayer} toggleModal={this.toggleModal} freeswinganalysis={this.freeSwingAnalysis} downloadMovie={this.downloadMovie}/>
      </div>
    );
  }
}

export default App;
